import React, { useState } from 'react';
import { Formik, FormikProps } from 'formik';
import { InputSearchFormikDebounce } from '../../Common/InputSearchDebounce';

interface ListItem {
    id: string;
    label: string;
}

interface SearchFormValues {
    searchValue: string;
}

interface SearchableListProps {
    listItems: ListItem[];
    initialSelectedId?: string;
    onSelectChanged: (id: string) => void;
}

export const SearchableList: React.FC<SearchableListProps> = ({ listItems = [], initialSelectedId, onSelectChanged }) => {
    const [filteredItems, setFilteredItems] = useState<ListItem[]>(listItems);
    const [selectedId, setSelectedId] = useState<string | undefined>(initialSelectedId);

    const initialValues: SearchFormValues = { searchValue: '' };

    const handleSearch = (values: SearchFormValues) => {
        const filtered = listItems.filter(item => item.label.toLowerCase().includes(values.searchValue.toLowerCase()));
        setFilteredItems(filtered);

        if (filtered.length === 1) {
            setSelectedId(filtered[0].id);
            onSelectChanged(filtered[0].id);
        }
    };

    const handleItemClick = (id: string) => {
        setSelectedId(id);
        onSelectChanged(id);
    };

    const handleClearSearch = (formikProps: FormikProps<SearchFormValues>) => {
        formikProps.setFieldValue('searchValue', '');
        setFilteredItems(listItems);
    };

    return (
        <div className="searchable-list">
            <div className="searchable-list__search-container">
                <Formik initialValues={initialValues} onSubmit={handleSearch}>
                    {formikProps => (
                        <div className="searchable-list__search-form">
                            <InputSearchFormikDebounce<SearchFormValues>
                                id="searchValue"
                                context={formikProps}
                                placeholder="Search..."
                                isCloseButtonVisible={formikProps.values.searchValue !== ''}
                                closeButtonOnClick={() => handleClearSearch(formikProps)}
                                searchButtonOnClick={() => handleSearch(formikProps.values)}
                                onChange={event => {
                                    const newValue = event.target.value;
                                    formikProps.setFieldValue('searchValue', newValue);
                                    handleSearch({ searchValue: newValue });
                                }}
                                className="searchable-list__search-bar"
                            />
                        </div>
                    )}
                </Formik>
            </div>
            <div className="searchable-list__list-container">
                <ul className="searchable-list__list">
                    {filteredItems.map(item => (
                        <li key={item.id} className="searchable-list__item">
                            <span
                                onClick={() => handleItemClick(item.id)}
                                className={`searchable-list__label ${item.id === selectedId ? 'searchable-list__selected' : ''}`}
                            >
                                {item.label}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
